import type { ComponentType } from "react";

/**
 * Default export of a CommonJS package that sets `__esModule` and
 * `exports.default` and has no ES module entry: lottie-react (its `browser`
 * UMD build), react-fade-in and react-player.
 *
 * Vite 8 bundles with Rolldown, which gives a default import of such a module
 * the Node interop: the binding holds `module.exports`, and the component is
 * its `default` property. The TypeScript declarations type the binding as the
 * component itself, and so do the Vitest and Vite dev transforms. This
 * function accepts both shapes and returns the component.
 */
export function cjsDefault<Props>(
  imported: ComponentType<Props> | { readonly default: ComponentType<Props> }
): ComponentType<Props> {
  return typeof imported === "function" ? imported : imported.default;
}
